<script>
export default {};
</script>

<template>
  <div class="auth-page">
    <div class="container-fluid p-0">
      <div class="row g-0 align-items-center">
        <div class="col-xxl-4 col-lg-4 col-md-6">
          <div class="row justify-content-center g-0">
            <div class="col-xl-9">
              <div class="p-4">
                <div class="card mb-0">
                  <div class="card-body">
                    <div class="auth-full-page-content rounded d-flex p-3 my-2">
                      <div class="w-100">
                        <div class="d-flex flex-column h-100">
                          <div class="mb-4 mb-md-5">
                            <router-link to="/" class="d-block auth-logo">
                              <img src="@/assets/images/logo-dark.png" alt="" height="22" class="auth-logo-dark me-start" />
                              <img src="@/assets/images/logo-light.png" alt="" height="22" class="auth-logo-light me-start" />
                            </router-link>
                          </div>
                          <div class="auth-content my-auto">
                            <div class="text-center">
                              <h5 class="mb-0">Reset Password</h5>
                              <p class="text-muted mt-2">Reset Password with Borex.</p>
                            </div>
                            <div class="alert alert-success text-center my-4 font-size-12" role="alert">
                              Enter your Email and instructions will be sent to you!
                            </div>
                            <form class="mt-4 pt-2">
                              <div class="form-floating form-floating-custom mb-4">
                                <input type="email" class="form-control" id="input-email" placeholder="Enter Email" required />
                                <div class="invalid-feedback">Please Enter Email</div>
                                <label for="input-email">Email</label>
                                <div class="form-floating-icon">
                                  <eva-icon name="email-outline"></eva-icon>
                                </div>
                              </div>
                              <div class="mb-3">
                                <button class="btn btn-primary w-100 waves-effect waves-light" type="submit">Reset</button>
                              </div>
                            </form>

                            <div class="mt-4 pt-3 text-center">
                              <p class="text-muted mb-0">
                                Remember It ?
                                <router-link to="/auth/login" class="text-primary fw-semibold">Sign In</router-link>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end auth full page content -->
        </div>
        <!-- end col -->
        <div class="col-xxl-8 col-lg-8 col-md-6">
          <div class="auth-bg bg-white py-md-5 p-4 d-flex">
            <div class="bg-overlay bg-white"></div>
            <!-- end bubble effect -->
            <div class="row justify-content-center align-items-center">
              <div class="col-xl-8">
                <div class="mt-4">
                  <img src="@/assets/images/login-img.png" class="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container fluid -->
  </div>
</template>
